import * as angular from 'angular';
import { MediaService } from './MediaService';
import login from 'modules/login';
//
export const mediaModule = angular
    .module('media', [login])
    .service('MediaService', MediaService)
    .name;
